/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const RESOURCE_ROOT_FACADE = '/sms';
const RESOURCE_PAGE_FACADE = '/isMobileNumber';

const validateMobileNumber = async ({ mobileNumber, mobileNumberType }) => {
    if (mobileNumberType === "mobile") {
        const jwtToken = await getAccessTokenSafely();
        const env = {
            rootUri: RESOURCE_ROOT_FACADE,
        };
        const resourcePage = `${RESOURCE_PAGE_FACADE}/${mobileNumber}`;
    
        return restClient.postFacade(env, resourcePage, jwtToken, { mobileNumber })
            .then((response) => response?.data?.isMobileNumber)
            .catch((error) => false);
    }

    return true;
};

export default validateMobileNumber;
